import React from "react";
import { useSelector } from "react-redux";
import { DragescentState } from "../../../../store/reducers/stateType";
import AllianceProfile from "./AllianceProfile";

const OwnAllianceProfile = () => {
  const alliance = useSelector((state: DragescentState) => state.governorate.alliance);
  const opponent = useSelector((state: DragescentState) => state.governorate.opponent);
  const war = useSelector((state: DragescentState) => state.governorate.war);

  return <AllianceProfile alliance={alliance} owner={true} opponent={opponent} war={war} />
};

export default OwnAllianceProfile;
